import { useRouter } from "next/router";
import { useEffect } from "react";

function withRouteChangeComplete(WrappedComponent: any, callbackFunc) {
  function HOC(props: any) {
    const router = useRouter();

    const routeEnd = () => {
      if (callbackFunc) {
        callbackFunc();
      }
    };

    useEffect(() => {
      router.events.on("routeChangeComplete", routeEnd);
      return () => {
        router.events.off("routeChangeComplete", routeEnd);
      };
    }, []);

    return (
      <WrappedComponent {...props} />
    );
  }
  return HOC;
}

export default withRouteChangeComplete;
